export default __webpack_public_path__ + "static/media/success.9d807165.svg";